import React from "react"
import { numWinners, timesActivity } from "../../../constants/activity-constants"

import "./modal-points.scss"

export default function ModalPoints(props) {
  const { userName, userPoints, userPosition } = props

  return (
    <div className="modal-points">
      <div className="modal-points-container">
        <div className="wrapper-star">
          <h2 className="wrapper-star__title">
            <span className="family-TrashHand color-blue size-40">
              Hola {userName},
            </span>
          </h2>
          <div className="wrapper-star__body">
            <p className="family-Bw-Black color-blue">
              Tus puntos:{" "}
              <span className="family-Bw-Black color-pink-heavy size-30">
                {userPoints}
              </span>
            </p>
            <p className="family-Bw-Black color-blue">
              Tu posición:{" "}
              <span className="family-Bw-Black color-pink-heavy size-30">
                {userPosition}
              </span>
            </p>
          </div>
          <p className="family-H-Medium size-17 color-blue">
            Si no estás en nuestro top {numWinners}{" "}
            <span className="family-Bw-Black">
              ¡sigue jugando y no te rindas!
            </span>{" "}
            tienes hasta el {timesActivity.fin.dia} de{" "}
            {timesActivity.fin.mes} para alcanzar los mejores puntajes.
          </p>
          <button
            className="btn-secondary--2"
            onClick={() => window.location.reload()}
          >
            ACEPTAR
          </button>
        </div>
        {/* <p className="family-H-Medium size-18 color-white">
          Por ti, por mí, por nosotras,
        </p>
        <p className="family-S-House size-40 color-yellow">¡Comparte Loving!</p> */}
      </div>
    </div>
  )
}
